import React from "react";
import { Footer } from "../../shared/footer.js";
import { Navbar } from "../../shared/navbar.js";
import Main from "./main.js";
export default function Container() {
    return (React.createElement("div", null,
        React.createElement(Navbar, null),
        React.createElement(Main, null),
        React.createElement(Footer, null)));
}
